// extracted by mini-css-extract-plugin
export default {"shortAddress":"ShortAddress_shortAddress__I3QIO"};